import { OFFERS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const OfferService = {
  getAll: (params: any) => requests.get(`${OFFERS_URL}`, params),
  create: (params: any) => requests.post(`${OFFERS_URL}`, params),
  getSingle: (id: number) => requests.get(`${OFFERS_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${OFFERS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${OFFERS_URL}/${id}`),
};